import './App.css';
import React from 'react';
import { BrowserRouter as
        Router,
    Switch,
    Route,
    Link,
    Redirect
} from "react-router-dom";
import Operation from './components/Http/Operations';
import SoapOperation from './components/Soap/SoapOperation.js';
import logo from './wiley-image.png';
import Auth from './components/Http/Auth';
import AuthSettle from './components/Http/AuthSettle';
import TokenAuth from './components/Http/TokenAuth';
import TokenAuthSettle from './components/Http/TokenAuthSettle';
import Tokenise from './components/Http/Tokenise';
import TokenSettle from './components/Http/TokenSettle';
import Validate from './components/Http/Validate';
import VoidAuth from './components/Http/VoidAuth';
import Checkout from './components/Http/Checkout';
import TokenRefund from './components/Http/TokenRefund';
import SoapProbe from './components/Soap/SoapProbe';
import SoapTokenAuth from './components/Soap/SoapTokenAuth';
import SoapTokenAuthSettle from './components/Soap/SoapTokenAuthSettle';
import SoapTokenRefund from './components/Soap/SoapTokenRefund';
import SoapTokenSettle from './components/Soap/SoapTokenSettle';
import SoapVoidAuth from './components/Soap/SoapVoidAuth';
import CookieParse from './components/CookieParse';
import Probe from './components/Http/Probe';
import OrderReviewSuccess from './components/Http/OrderReviewSuccess';
import PageNotFound from './PageNotFound';
import Responseoperation from './components/Http/Responseoperations';
import LansaCookieParse from './components/LansaCookieParse';
import { env } from './env';
import ConsolidatedUI from './components/Http/consolidatedUI/ConsolidatedUI';

function App() {
    const url = env.REACT_APP_URL;
    const soapUrl = env.REACT_APP_SOAPURL;
    if(env.REACT_APP_WPS_PAYMENT_JS_URL) {
        document.getElementById('wpsPaymentJsScript').src = env.REACT_APP_WPS_PAYMENT_JS_URL;
    } else {
        console.log("Warning----> REACT_APP_WPS_PAYMENT_JS_URL not found")
    }

    var d = new Date().getFullYear();
    var indexTemplate = (
        <div className="index-page">
            <div className="operation-type">
                <Link to="/http">
                    <div className="http-link">
                        <h2>HTTP Interface</h2>
                        <p>{window.location.origin +"/http"}</p>
                        <p>Test HTTP Interface</p>
                    </div>
                </Link>
            </div>
            <div className="operation-type">
                <Link to="/soapui">
                    <div className="soap-link">
                        <h2>SOAP Interface</h2>
                        <p>{window.location.origin +"/soapui"}</p>
                        <p>Test SOAP Interface</p>
                    </div>
                </Link>
            </div>
        </div>);



    return (
        <div className="App" >
            <Router>
                <div className="test-harness-page-header">
                    <div className='test-harness-logo'>
                        <Link to="/index">
                            <img src={logo} alt="wiley-logo" />
                        </Link>
                    </div>
                    <Switch>
                        <Route path="/http" >
                            <div className="test-harness-page-title">
                                HTTP Operation Test Page
                            </div>
                            <Operation />
                        </Route>
                        <Route path="/soapui" >
                            <div className="test-harness-page-title">
                                SOAP Operation Test Page
                            </div>
                            <SoapOperation />
                        </Route>
                        <Route path="/response" >
                            <div className="test-harness-page-title">
                                HTTP Operation Test Page
                            </div>
                            <Responseoperation />
                        </Route>
                        <Route path="/lansaresponse" >
                            <div className="test-harness-page-title">
                                HTTP Operation Test Page
                            </div>
                            <Responseoperation />
                        </Route>
                    </Switch>
                </div>
                <Switch>
                    <Route path="/index">
                        <div className="page-description-mt"></div>
                    </Route>
                    <Route path="/response">
                        <div className="page-description">
                            These tests will launch a checkout process for each required operation.
                        </div>
                    </Route>
                    <Route path="/lansaresponse">
                        <div className="page-description">
                            These tests will launch a checkout process for each required operation.
                        </div>
                    </Route>
                    <Route path="/http">
                        <div className="page-description">
                            These tests will launch a checkout process for each required operation.
                        </div>
                    </Route>
                    <Route path="/soapui">
                        <div className="page-description">
                            These tests will launch a checkout process for each required operation.
                        </div>
                    </Route>
                    <Route path="*">
                        <div className="page-description-mt"></div>
                    </Route>
                </Switch>

                <div className="page-body">
                    <Switch>
                        <Route path="/index" >
                            <div>{indexTemplate} </div>
                        </Route>
                        <Route exact path="/">
                            <Redirect to="/index" />
                        </Route>
                        <Route path="/response">
                            <CookieParse />
                        </Route>
                        <Route path="/lansaresponse">
                            <LansaCookieParse />
                        </Route>
                        <Route exact path="/http">
                            <Redirect to="/http/probe" />
                        </Route>
                        <Route path="/http/probe">
                            <Probe apiUrl={url}/>
                        </Route>
                        <Route path="/http/auth">
                            <Auth apiUrl={url}/>
                        </Route>
                        <Route path="/http/authsettle" >
                            <AuthSettle apiUrl={url}/>
                        </Route>
                        <Route path="/http/tokenauth" >
                            <TokenAuth apiUrl={url}/>
                        </Route>
                        <Route path="/http/tokenauthsettle" >
                            <TokenAuthSettle apiUrl={url}/>
                        </Route>
                        <Route path="/http/tokenise" >
                            <Tokenise apiUrl={url}/>
                        </Route>
                        <Route path="/http/tokensettle" >
                            <TokenSettle apiUrl={url}/>
                        </Route>
                        <Route path="/http/validate" >
                            <Validate apiUrl={url}/>
                        </Route>
                        <Route path="/http/voidauth">
                            <VoidAuth apiUrl={url} />
                        </Route>
                        <Route path="/http/checkout">
                            <Checkout apiUrl={url} />
                        </Route>
                        <Route path="/http/consolidated-ui">
                            <ConsolidatedUI apiUrl={url} />
                        </Route>
                        <Route path="/http/successredirect">
                            <OrderReviewSuccess></OrderReviewSuccess>
                        </Route>
                        <Route path="/http/tokenrefund">
                            <TokenRefund apiUrl={url} />
                        </Route>
                        <Route path="/soapui/probe" >
                            <SoapProbe apiUrl={soapUrl} />
                        </Route>
                        <Route exact path="/soapui">
                            <Redirect to="/soapui/probe" />
                        </Route>
                        <Route path="/soapui/tokenauth" >
                            <SoapTokenAuth apiUrl={soapUrl} />
                        </Route>
                        <Route path="/soapui/tokenauthsettle" >
                            <SoapTokenAuthSettle apiUrl={soapUrl} />
                        </Route>
                        <Route path="/soapui/tokenrefund" >
                            <SoapTokenRefund apiUrl={soapUrl} />
                        </Route>
                        <Route path="/soapui/tokensettle" >
                            <SoapTokenSettle apiUrl={soapUrl} />
                        </Route>
                        <Route path="/soapui/voidauth">
                            <SoapVoidAuth apiUrl={soapUrl} />
                        </Route>
                        <Route path="*">
                            <PageNotFound/>
                        </Route>
                    </Switch>
                </div>
                <Switch>
                    <Route path="/index">
                        <div className="url-span-mt"></div>
                    </Route>
                    <Route path="/http">
                        <div className="url-span">Test Server -  {window.location.origin +"/http"}</div>
                    </Route>
                    <Route path="/response">
                        <div className="url-span">Test Server -  {window.location.origin +"/http"}</div>
                    </Route>
                    <Route path="/lansaresponse">
                        <div className="url-span">Test Server -  {window.location.origin +"/http"}</div>
                    </Route>
                    <Route path="/soapui">
                        <div className="url-span">Test Server -  {window.location.origin +"/soapui"}</div>
                    </Route>
                    <Route path="*">
                        <div className="url-span-mt"></div>
                    </Route>
                </Switch>
                <div className="test-harness-footer"><a href='https://www.wiley.com/en-us/copyright' target="_blank" rel="noopener noreferrer">Copyright &copy; 2000-{d}</a>&nbsp;by John Wiley & Sons, Inc., or related companies. All rights reserved.</div>
            </Router>
        </div>
    );
}

export default App;